import defaultsDeep from 'lodash/defaultsDeep'

import defaultConfig from './default'

export default defaultsDeep(
  {
    sentry: {
      enabled: true,
      environment: 'production',
    },
    amplify: {
      Auth: {
        region: 'eu-west-1',
        userPoolId: 'eu-west-1_vBNF4EZ4k',
        userPoolWebClientId: 'ahbjc11od64ofu9rjo32312f6',
      },
    },
    services: {
      api: {
        baseUrl: 'https://catalog.craftcloud3d.com',
      },
      partner: {
        baseUrl: 'https://partner-api.craftcloud3d.com',
      },
      craftcloud: {
        baseUrl: 'https://craftcloud3d.com',
      },
      internal: {
        baseUrl: 'https://internal-api.craftcloud3d.com',
      },
    },
  },
  defaultConfig
)
